// ----------------------------------------------------------------------- imports externos
import { useEffect, useState } from "react";

// ----------------------------------------------------------------------- imports internos
import { crearLlave, fueCancelada } from "../../services/acceso";
import {
  esCompu,
  llavesDisponibles,
  tieneLlave,
  tomarRecienEntro,
} from "../../shared/acceso";
import "./AvisoLlave.css";

/* «Generá una llave de acceso» (Igna, 02/11): después de entrar en una compu
 * que todavía no tiene llave, una vez por ingreso. Explica cómo hacerla con el
 * celular, que es lo que tiene todo el mundo: la compu muestra un código, se
 * escanea con la cámara, y la llave queda guardada en el teléfono. La próxima
 * vez, «Entrar con llave de acceso» y se confirma con la huella o la cara.
 *
 * «Más tarde» sólo lo cierra: vuelve a aparecer en el próximo ingreso, hasta
 * que haya una llave en este navegador. */
const AvisoLlave = () => {
  const [abierto, setAbierto] = useState(false);
  const [estado, setEstado] = useState(""); // "" | creando | lista | error
  useEffect(() => {
    if (tomarRecienEntro() && esCompu() && llavesDisponibles() && !tieneLlave()) {
      setAbierto(true);
    }
  }, []);

  if (!abierto) return null;

  const crear = async () => {
    setEstado("creando");
    try {
      await crearLlave();
      setEstado("lista");
    } catch (e) {
      setEstado(fueCancelada(e) ? "" : "error");
    }
  };

  return (
    <div className="avl-fondo" role="dialog" aria-modal="true" aria-labelledby="avl-titulo">
      <div className="avl">
        {estado === "lista" ? (
          <>
            <h2 id="avl-titulo">Llave creada</h2>
            <p>
              La próxima vez tocá <b>Entrar con llave de acceso</b> y confirmá
              con el celular. Sin clave.
            </p>
            <div className="avl__botones">
              <button type="button" className="avl__si" onClick={() => setAbierto(false)}>
                Listo
              </button>
            </div>
          </>
        ) : (
          <>
            <h2 id="avl-titulo">Generá una llave de acceso</h2>
            <p>Para no tener que seguir poniendo la clave cada vez.</p>
            <ol className="avl__pasos">
              <li>
                Tocá <b>Crear llave</b>.
              </li>
              <li>
                La compu te pregunta dónde guardarla: elegí <b>Usar un teléfono
                o tablet</b> (puede decir «Otro dispositivo»).
              </li>
              <li>
                Aparece un código: escanealo con la <b>cámara del celular</b> y
                confirmá con tu huella, tu cara o el bloqueo del teléfono.
              </li>
              <li>
                Desde ahí, para entrar: <b>Entrar con llave de acceso</b>, y
                confirmás en el celu.
              </li>
            </ol>
            <p className="avl__chico">
              El celular tiene que tener el Bluetooth prendido. Si la compu te
              ofrece guardarla ahí mismo (con el PIN de Windows), también sirve.
            </p>
            {estado === "error" && (
              <p className="avl__err">No se pudo crear. Probá de nuevo.</p>
            )}
            <div className="avl__botones">
              <button
                type="button"
                className="avl__si"
                onClick={crear}
                disabled={estado === "creando"}
              >
                {estado === "creando" ? "Creando…" : "Crear llave"}
              </button>
              <button type="button" className="avl__no" onClick={() => setAbierto(false)}>
                Más tarde
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AvisoLlave;
